import request from '@/service/request'

export const getPhysioPage = (params: HOME.PHYSIO_QUERY_PARAMS) => {
  return request<SERVICE.ResponsePage<HOME.PHYSIO[]>>({
    url: '/admin/staff/page',
    method: 'GET',
    params
  })
}

export const exportPhysioExcel = (params: HOME.PHYSIO) => {
  return request<Blob>({
    url: '/admin/staff/export',
    method: 'GET',
    params
  })
}

export const updatePhysionScore = (params: {staffId: string, newScore: string}) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/staff/export',
    method: 'PUT',
    params
  })
}

export const updatePhysionOrderCount = (params: {staffId: string, increment: string}) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/staff/export',
    method: 'PUT',
    params
  })
}

export const updatePhysionAvailability = (params: {staffId: string, isAvailable: boolean}) => {
  return request<SERVICE.Response<string>>({
    url: `/admin/staff/${params.staffId}/availability?isAvailable=${params.isAvailable}`,
    method: 'PUT'
  })
}

export const delPhysioById = (id: string) => {
  return request<SERVICE.Response<string>>({
    url: `/admin/staff/${id}`,
    method: 'DELETE'
  })
}

export const getPhysioById = (id: string) => {
  return request<SERVICE.Response<HOME.PHYSIO>>({
    url: `/admin/staff/${id}`,
    method: 'GET'
  })
}

export const addPhysio = (data: HOME.PHYSIO) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/staff',
    method: 'POST',
    data
  })
}

export const updatePhysio = (data: HOME.PHYSIO) => {
  return request<SERVICE.Response<string>>({
    url: `/admin/staff/${data.id}`,
    method: 'PUT',
    data
  })
}

export const getCommentPageByPhysioId = (params: { staffId: string} & API.Params) => {
  return request<SERVICE.ResponsePage<HOME.COMMENT[]>>({
    url: '/admin/staff-evaluation/page',
    method: 'GET',
    params
  })
}

export const updateCommentStatusByEvaluationId = (params: { evaluationId: string, isDisplayed: string}) => {
  return request<SERVICE.ResponsePage<HOME.COMMENT[]>>({
    url: `/admin/staff-evaluation/${params.evaluationId}/display-status?isDisplayed=${params.isDisplayed}`,
    method: 'PUT'
  })
}

export const delCommentByEvaluationId = (evaluationId: string) => {
  return request<SERVICE.Response<Boolean>>({
    url: `/admin/staff-evaluation/${evaluationId}`,
    method: 'DELETE'
  })
}
